<template>
  <kfield
    :id="componentProps.columnName"
    :name="componentProps.columnName"
    :component="component"
    :label="t('columns.' + componentProps.columnName)"
    :validator="componentProps.validators"
    :disabled="disabled"
    :additionalProperties="componentProps.additionalProperties"
  >
    <template v-slot:stringTemplate="{ props }">
      <ApplicationFieldString
        v-bind="props"
        @change="props.onChange"
      />
    </template>
    <template v-slot:dateTemplate="{ props }">
      <ApplicationFieldDate
        v-bind="props"
        @change="props.onChange"
      />
    </template>
    <!-- <template v-slot:booleanTemplate="{ props }">
     <ApplicationFieldBoolean
        v-bind="props"
        @change="props.onChange"
      />
    </template>
    <template v-slot:dropDownListTemplate="{ props }">
     <ApplicationFieldDropDownList
        v-bind="props"
        @change="props.onChange"
      />
    </template>
    <template v-slot:htmlTemplate="{ props }">
     <ApplicationFieldHtml
        v-bind="props"
        @change="props.onChange"
      />
    </template> -->
  </kfield>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
const { t } = useI18n();
import { Field as kfield } from "@progress/kendo-vue-form";
import { type FieldValidatorType } from "@progress/kendo-vue-form";
import { computed, inject} from "vue";

import ApplicationFieldString from "./ApplicationFieldString.vue";
import ApplicationFieldDate from "./ApplicationFieldDate.vue";
// import ApplicationFieldBoolean from "./ApplicationFieldBoolean.vue";
// import ApplicationFieldDropDownList from "./ApplicationFieldDropDownList.vue";
// import ApplicationFieldHtml from "./ApplicationFieldHtml.vue";
import { useLogger } from "vue-logger-plugin";
const logger = useLogger();

// Define the props
const componentProps = defineProps({
  columnName: {
    type: String,
    required: true,
  },
  validators:{
    type: Array<FieldValidatorType>
  },
  keyField: {
    type: Boolean,
  },
  columnDataType: {
    type: String as ()=> "string" | "boolean" | "date",
    default: "string",
  },
  columnControlType: {
    type: String as () => "DropDownList" | "HtmlEditor" |null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  additionalProperties: {
    type: Object,
  },
});
const formProperties = inject("ApplicationEditFormProperties") as ApplicationEditFormProperties;

let component = "stringTemplate";
if (componentProps.columnDataType === "boolean") {
  component = "booleanTemplate";
}
if (componentProps.columnDataType === "date") {
  component = "dateTemplate";
}
if (componentProps.columnControlType === "DropDownList") {
  component = "dropDownListTemplate";
}
if (componentProps.columnControlType === "HtmlEditor") {
  component = "htmlTemplate";
}
logger.debug("props: ", componentProps, " component: ", component);

const disabled = computed(() => {
  let value = componentProps.disabled;
  if (!value){
    value = (componentProps.keyField && formProperties.mode === "update");
  }
  logger.debug("props: ", componentProps, " disabled: " , disabled);
  return value;
});
</script>

